import { Config } from './config';
import { environmentBase } from './environment.base';

export const environment: Config = {
  ...environmentBase,
  API_BASE_PATH: 'https://backend.test.tvd.cc-n.dev',
};
